import type { ReactNode } from 'react';
import type { BtlApplication, HouseholdsToHasIndividuals } from 'api/btlApplicationForm/types';
import type { MissingCaseFields } from 'pages/BtlApplicationFormPage/types';
import type { TypedFormatMessageFn } from 'types/intl';

export type CaseSidebarFeatureFlags = Record<string, boolean>;

export enum CaseSidebarItemId {
  OVERVIEW = 'OVERVIEW',
  CUSTOMER_FILES = 'CUSTOMER_FILES',
  EVIDENCE = 'EVIDENCE',
  FINANCING = 'FINANCING',
  APPLICANTS = 'APPLICANTS',
  EXPENSES = 'EXPENSES',
  PRODUCT = 'PRODUCT',
  PROPERTY = 'PROPERTY',
  AFFORDABILITY_CHECK = 'AFFORDABILITY_CHECK',
  TOP_SLICING = 'TOP_SLICING',
  SUBMIT_DIP = 'SUBMIT_DIP',
  SOLICITORS = 'SOLICITORS',
  BANK_DETAILS = 'BANK_DETAILS',
  SUBMIT_APPLICATION = 'SUBMIT_APPLICATION',
  VALUATION = 'VALUATION',
  POST_OFFER = 'POST_OFFER',
  COMMUNICATION = 'COMMUNICATION',
  ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION',
}

export enum CaseSidebarSection {
  DOCUMENTS = 'DOCUMENTS',
  APPLICATION = 'APPLICATION',
  OTHER = 'OTHER',
}

export interface CaseSectionItem {
  id: CaseSidebarItemId;
  title: string;
  subTitle: string;
  isDisabled: boolean;
  component: ReactNode;
  warnings: string[];
  iconItemId?: CaseSidebarItemId;
}

export interface CaseSection {
  title: string;
  children: CaseSectionItem[];
}

export interface CaseSidebarState {
  sections: CaseSection[];
  isTopSlicing: boolean;
}

export interface BuildBtlCaseSidebarParams {
  application: BtlApplication;
  formatMessage: TypedFormatMessageFn;
  isAffordabilityPassed?: boolean;
  isAffordabilityRunRequired?: boolean;
  missingFields?: MissingCaseFields;
  householdsToHasIndividuals?: HouseholdsToHasIndividuals;
  activeItemId?: CaseSidebarItemId;
  components: Partial<Record<CaseSidebarItemId, ReactNode>>;
  featureFlags?: CaseSidebarFeatureFlags;
}

export interface BuildBtlCaseSidebarResult {
  overviewItem: CaseSectionItem;
  state: CaseSidebarState;
}

export interface StatusSidebarChange {
  add?: Partial<Record<CaseSidebarSection, CaseSidebarItemId[]>>;
  remove?: CaseSidebarItemId[];
}

export type SectionPagesMap = Record<CaseSidebarSection, CaseSidebarItemId[]>;
